import es from './localeEs';
import pt from './localePt';

const locales = { es, pt };

export default locales;
